<template>
  <ed-modal
    :show="show"
    :title="title"
    primary-button="false"
    secondary-button="false"
    type="medium"
    @close="onClose"
    @validate="send"
    :closeOnEsc="true"
  >
    <div class="content" slot="body">
      <span class="description-section-modal">
        The supplier will receive an email letting them know that your company uses EvedPay!
        Eved's merchant services team will assist them with the sign-up process if they
        don't already have an account.
      </span>
      <form @submit.prevent="validate" class="col-md-offset-1 col-md-11 mb-offset-64">
        <ed-section wide class="no-border" 
          v-for="(supplier, i) in invite" :key="i"
        >
          <span slot="description" v-if="i === 0">
          </span>
          <div class="col-md-11">
            <div v-if="$v.$invalid && $v.$dirty" class="error-summary panel panel-danger panel-side no-icon">
              <div class="panel-heading">
              </div>
              <div class="panel-body">
                <div>
                  All fields are required unless labeled 'optional'
                </div>
              </div>
            </div>
            <div class="form-group list" v-loading.8="api.$.supplier.customFields">

              <!-- CUSTOM FIELDS -->
              <transition-group name='field'>
                <div v-for='(field, index) in mapFields'
                  :data-field='field.key'
                  :key='hash(field)'
                  class='form-group list'
                >
                  <component
                    :is='field.type'
                    :field-label='field.label'
                    :type='field.nativeType'
                    :maxlength='field.maxLength'
                    placeholder=' '
                    :required='field.required'
                    :optional='field.optional'
                    :error='$v.Supplier[field.key] && $v.Supplier[field.key].$error'
                    :helptip-header='``'
                    :helptip-body='validationMessage(field)'
                    :options='fieldOptions(field)'
                    :track-by='"text"'
                    :button-label='"Upload File"'
                    :button-position='"bottom"'
                    :post-action='api.env + field.dataSource.url'
                    :headers='headers'
                    :upload-auto='true'
                    :multiple='multiple(field)'
                    :readonly='field.type === FIELD_TYPES.file ? true : false'
                    :show-helptip-icon='false'
                    :endpoint='field.type === FIELD_TYPES.file ? field.dataSource.url : null'
                    :openEndpoint='field.dataSource.url'
                    @open='fetchOptions(field)'
                    @select='() => { selectOption(field) }'
                    @hook:created='update(field)'
                    @hook:beforeCreate='beforeCreateField(field)'
                    label='text'
                    v-model='supplier[field.key]'
                    v-show='shouldBeVisible(field)'
                    class='full-width list'
                    ref='fields'
                    v-bind='meta(field.key, index, field)'
                    :integer='field.integer'
                    xserver-search='field.serverSearch'
                    xsearch='query => fetchOptions(field, query)'
                  />
                  <div v-if='shouldShowInfo(field).label' class='alternate'>
                    <label>
                      {{ field.label }}
                      <em class='optional-field-label' v-if='!field.required'>&nbsp;- optional</em>
                    </label>
                    <div class='info-field'>
                      <em>Select <strong>{{ shouldShowInfo(field).label }}</strong> {{ shouldShowInfo(field).meta }}</em>
                    </div>
                  </div>
                </div>
              </transition-group>
                <transition-group name='field' :duration='1000'>
                  <div v-if='customFields.length && !loading' key='submit'>
                  <!-- SEND -->
                    <br />

                  </div>
                  <small key='wait' v-else> {{ null && $t("Wait a second...") }} </small>
                </transition-group>

            </div>
          </div>
        </ed-section>
      </form>
    </div>
    <div class="buttons clear" slot="footer">
      <ed-button button-class="btn btn-default" @click="onClose">Cancel</ed-button>
      <ed-button :class="{ invalid: $v.$invalid && $v.$dirty, disabled: !canSubmit }"
        :disabled='!canSubmit'
        :endpoint='submitAction'
        @click='send'>Send Invite</ed-button>
    </div>
  </ed-modal>
</template>

<script>

// import { Eved, EventBus } from '@/event-bus'

import { required } from 'vuelidate/lib/validators'

const Supplier = {
  //
}

const FIELD_TYPES = {
  number: 'ed-input',
  textarea: 'ed-textarea',
  text: 'ed-input',
  email: 'ed-input',
  select: 'ed-select',
  date: 'ed-datepicker',
  file: 'ed-upload'
}

const opIn = (value, collection) => !!~collection.indexOf(value)
const opNotIn = (...args) => !opIn(...args)

const operators = {
  'IN': opIn,
  'NOT IN': opNotIn
}

const fieldMapper = field => ({
  ...(field.constructor.name === 'Object' ? field : {}),

  type: FIELD_TYPES[field.type] || field.type || FIELD_TYPES['text'],
  nativeType: field.type === 'number' ? 'text' : field.type || 'text',
  key: field.name || field.key || (field.label || field).replace && (field.label || field).replace(/ /g, ''),
  label: getLabel(field.label || field),
  required: field.required || (field.validation || {}).required,
  dependency: (field.validation || {}).dependencies[0],
  integer: field.type === 'number',
  multiple: field.multiple,
  // serverSearch: field.serverSearch,
  serverOptions: field.multiple && field.type === 'select' && (field.dataSource || {}).url
})

const getLabel = label => {
  const labels = global.app.$user.sessionSettings.CompanySettings.Labels
  const tokens = label.match(/\{\{\w+\}\}/g)
  let r = label

  tokens && tokens.forEach(token => {
    const label = token.replace('{{', '').replace('}}', '')
    r = r.replace(token, labels[label])
  })

  return r
}

const additionalFields = [
  //
]

const TEMPLATE_FIELD = 'templateName'
const validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line

export default {
  name: 'AddSupplier',
  props: {
    model: Object,
    invoiceId: Number,
    eventHub: Object,
    operation: String
  },

  created() {
    this.getCustomFields()
    this.Supplier = this.invite[0]
  },

  mounted() {
    //
  },

  beforeLeave() {
    return this.check()
  },

  data() {
    return {
      FIELD_TYPES,
      //
      headers: {
        'Authorization': `Bearer ${this.$user.sessionSettings.Token}`
      },
      submitAction: '',
      canSubmit: true,
      invite: [ utils.copy(Supplier) ],
      options: {},
      Supplier: null,
      sentInvite: false,
      showCancelBtn: false,
      customFields: [],
      counter: 0,
      loading: false,
      lastUpdatedKey: '',

      show: true,
      title: 'Invite Supplier',

      hash: (field, form = this.invite[0]) => {
        const hash = field.key + /* this.options.length + */ field.validation.dependencies.map(d => (form[d.name] || {}).text).join('-') + this.counter
        // field.hash = field.hash || hash
        return hash
      },

      shouldBeVisible: (field, form = this.invite[0]) => {
        if (this.loading) return false
        const dependencies = !!field.validation.dependencies.length
        field.validation.unresolvedDependencies = []

        return !dependencies || field.validation.dependencies.some(dependency => {
          const dependsOn = form[dependency.name]
          const dependsOnValue = (dependsOn || {}).text
          const collection = dependency.values

          const resolved = operators[dependency.operator](dependsOnValue, collection) || !collection.length

          if (resolved) {
            field.validation.unresolvedDependencies.push(dependency.name)
          }

          return dependsOnValue && resolved
        })
      },

      shouldShowInfo: (field, form = this.invite[0]) => {
        if (this.loading) return false
        let info = ''

        if (field.type === FIELD_TYPES.file) {
          const dependsOn = field.validation.unresolvedDependencies[0]
          const dependsOnLabel = (this.mapFields.find(customField => customField.name === dependsOn) || {}).label
          const dependsOnValue = dependsOn && (form[dependsOn] || {}).text

          info = !dependsOnValue && {
            label: dependsOnLabel,
            meta: dependsOn === (field.validation.dependencies[0] || {}).name ? 'first' : ''
          }
        }

        return info
      },

      validationMessage: field => this.$v.Supplier[field.key] && this.$v.Supplier[field.key].$error
        ? field.description || `Please fill in ${this.$v.Supplier[field.key].validationRule === false && this.$v.Supplier[field.key].$model ? 'a valid' : 'the'} ${field.label}`
        : field.description
    }
  },

  validations() {
    return {
      Supplier: {
        ...this.validationRules
        // add extra validations here if needed
      }
    }
  },

  computed: {
    mapFields() {
      return this.customFields.map(fieldMapper)
    },

    validationRules() {
      const validations = {}
      this.mapFields.forEach(field => {
        validations[field.key] = field.required
          ? {
            isValid: v => !this.shouldBeVisible(field)
              ? true
              : field.nativeType === 'email'
                ? required(v) && validEmail.test(String(v))
                : required(v)

          } : {
            isValid: v => {
              return !this.shouldBeVisible(field)
                ? true
                : field.nativeType === 'email'
                  ? typeof v !== 'undefined' && validEmail.test(String(v))
                  : true
            }
          }
      })
      return validations
    }
  },

  methods: {
    send() {
      if (this.canSubmit) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          console.log(this.mapToSend(this.invite[0]))
          return
        }

        this.api.post(this.submitAction,
          this.mapToSend(this.invite[0])
        ).then(r => {
          this.counter++
          this.showConfirmation()
          this.cancel()
          this.prefillCustomFields(this.formFields)
          this.show = false
        }).catch(e => {
          this.showError(e.response)
        })
      }
    },

    onClose() {
      this.eventHub.$emit('onCloseAddSupplier', {})
      this.show = false
    },

    preSend(field) {
      const fieldEl = document.querySelector(`[data-field=${field}`)

      // if (!~prevalidateFields.indexOf(field)) {
      //   return
      // }

      fieldEl.classList.add('loading')

      this.api.post(this.submitAction,
        this.mapToSend(this.invite[0])
      ).then(r => {
        fieldEl.classList.remove('loading')
      }).catch(e => {
        fieldEl.classList.remove('loading')
        this.showError(e.response)
      })
    },

    meta(field, index) {
      const hasTemplateField = this.customFields.find(f => f.name === TEMPLATE_FIELD)

      if (field !== TEMPLATE_FIELD && hasTemplateField && !this.Supplier[TEMPLATE_FIELD]) {
        this.canSubmit = false
        return {
          disabled: true,
          class: 'dim disabled'
        }
      } else {
        if (this.Supplier[TEMPLATE_FIELD]) {
          this.canSubmit = true
        }
      }
    },

    showConfirmation() {
      this.invite[0].Email &&
      this.$notifications.notify({
        message: `An invitation has been sent to ${this.invite[0].SupplierName || ''} (${this.invite[0].Email})`,
        type: 'info',
        placement: { from: 'top', align: 'center' }
      })
    },

    showError(r) {
      this.invite[0].Email &&
      r.data.error &&
      r.data.error.name === 'ValidationError' &&
      this.$notifications.notify({
        timeout: 10000,
        message: r.data.error.message,
        type: 'info-warn',
        placement: { from: 'top', align: 'center' }
      })
    },

    addMore() {
      this.showCancelBtn = this.emptyInvite()
      this.invite.push(Supplier)
    },

    cancel() {
      // this.invite = [ utils.copy(Supplier) ]
      this.emptySupplier(this.invite[0])
      document.querySelector('.main-panel').scrollTo(0, 0)
      this.$v.$reset()
    },

    emptySupplier(obj) {
      const fields = [...this.mapFields, ...additionalFields]
      fields.forEach(field => {
        if (field.key) {
          obj[field.key] = null
        }
      })
      obj.MeetingDate = null
    },

    validate() {
      //
    },

    check() {
      return this.invite.filter(this.validateSupplier).length || this.emptyInvite() || this.sentInvite
    },

    emptyInvite() {
      return this.invite.length === 1 &&
        !this.invite[0].supplier &&
        !this.invite[0].fullName &&
        !this.invite[0].email
    },

    validateSupplier(supplier) {
      return supplier.supplier && supplier.fullName && supplier.email
    },

    getCustomFields() {
      this.api.get(this.api.$.supplier.customFields, {})
        .then(r => {
          if (r.data && r.data.form) {
            this.submitAction = r.data.form.action
            this.customFields.push(...r.data.form.fieldsets[0].fields, ...additionalFields)

            //
            this.formFields = r.data.form.fieldsets[0].fields
            this.prefillCustomFields(this.formFields)
          }
        })
    },

    prefillCustomFields(fields) {
      fields.map(field => {
        if (field.values.length) {
          if (field.type === 'select') {
            if (field.name !== TEMPLATE_FIELD) {
              this.invite[0][field.name] = {
                value: 0,
                text: field.values[0]
              }
            }
          } else {
            this.invite[0][field.name] = field.values[0]
          }
        }
      })
    },

    async fetchOptions(field, i) {
      if (
        this.options[field.key] &&
        this.options[field.key].length &&
        !field.dataSource.queryParameters.length // &&
        // !field.serverSearch
      ) return
      // console.log('getting options from server', field.key)
      const options = await this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0], i))
      options && options.data
        ? this.options[field.key] = options.data
        : void 0
    },

    update(field) {
      if (this.options[field.key]) {
        // console.log('creating', field.key)
      }
    },

    selectOption(field) {
      const isServerOptions = field.serverOptions
      const shouldRefreshFields = !isServerOptions

      if (shouldRefreshFields) {
        this.counter++
      }
      this.clearDependencies(field)
    },

    clearDependencies(field, form = this.invite[0]) {
      this.lastUpdatedKey = field.name

      if (this.lastUpdatedKey === TEMPLATE_FIELD) {
        // reset files
        const customField = this.customFields.find(f => f.type === 'file')

        if (customField && this.shouldBeVisible(customField)) {
          form[customField.name] = null
          delete form[customField.name]
          this.options[field.key] = null
          delete this.options[field.key]
          this.$nextTick(() => {
            this.beforeCreateField(customField, true)
          })
        }
      }

      if (field.type === FIELD_TYPES.select) {
        Object.keys(form).forEach(f => {
          const customField = this.customFields.find(f => ~f.dataSource.queryParameters.indexOf(field.name))
          if (customField) {
            form[customField.name] = null
            delete form[customField.name]
          }
        })
      }
    },

    beforeCreateField(field, force) {
      if (!field.serverSearch && force === undefined && (!this.shouldBeVisible(field) || field.dataSource.url === '')) return

      // File fields
      if (field.type === FIELD_TYPES.file || field.type === 'file') {
        this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(options => {
          if (options && options.data) {
            this.invite[0][field.name] = this.mapAttachments(options.data)
            this.options[field.key] = options.data
          }
          if (force) {
            this.$forceUpdate()
          }
        })
      }

      if (field.integer) {
        if (this.lastUpdatedKey === TEMPLATE_FIELD || !this.Supplier[TEMPLATE_FIELD]) {
          this.loading = true
          this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(options => {
            if (options && typeof options.data !== 'undefined') {
              this.$set(this.Supplier, field.key, options.data)
            }
            this.loading = false
          })
        }
      }

      if (field.serverOptions) {
        if (this.lastUpdatedKey === TEMPLATE_FIELD || !this.Supplier[TEMPLATE_FIELD]) {
          this.loading = true
          this.$loading = true
          this.api.get(field.dataSource.url + '?' + this.query(field, this.invite[0])).then(options => {
            if (options && typeof options.data !== 'undefined') {
              this.$set(this.Supplier, field.key, options.data)
              this.options[field.key] = options.data
            }
            this.loading = false
            this.$loading = false
          })
        }
      }
    },

    query(field, form, q = '') {
      let query = ''

      if (field.serverSearch) {
        query += `q=${q}`
      }

      field.dataSource.queryParameters.map(param => {
        const value = (form[param] || {}).text || form[param]
        query += value ? `&${param}=${encodeURIComponent(value)}` : ''
      })

      return query
    },

    fieldOptions(field) {
      // console.log('rendering options for', field.key)
      if (!this.shouldBeVisible(field)) return []

      if (this.options[field.key]) return field.options || this.options[field.key] || []

      // this.options[field.key] ||
      this.$set(this.options, field.key, [])

      // File fields
      if (field.type === FIELD_TYPES.file) {
        this.$set(this.Supplier, field.key, [])
      }
    },

    multiple(field) {
      return field.multiple
    },

    mapAttachments(files) {
      let attachments = []
      for (var f in files) {
        if (files.hasOwnProperty(f)) {
          let entry = files[f]
          attachments.push({
            fileObject: true,
            id: entry.id,
            name: entry.name,
            file: entry.file,
            path: entry.path,
            type: entry.type,
            size: entry.size * 1024,
            success: true,
            readonly: true
          })
        }
      }
      return attachments
    },

    mapToSend(o) {
      let output = []

      Object.keys(o).forEach(k => {
        const customField = this.customFields.find(field => field.name === k) || {}
        output.push({
          name: k,
          multiple: customField.multiple,
          type: customField.type,
          values: o[k] && o[k] !== 'undefined' ? o[k].map ? o[k].map((k) => multiselectOrFiles(k, customField)) : [o[k].text || o[k]] : []
        })
      })

      return output

      function fileId(file) {
        const response = file.response && file.response.length && file.response
        return JSON.parse(response || '{}').id || file.id
      }

      function multiselectOrFiles(k, field) {
        const isFilesField = field.type === 'file'
        if (isFilesField) {
          return fileId(k)
        } else {
          return k.value
        }
      }
    }
  }
}

</script>


<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.content >>> .dawn-page-section {
  .title-area .description.description {
    font-size: $font-size-base;
  }
}

.content >>> .form-group {

  &.invalid .dawnSelect[class], .form-control[class][error] {
    box-shadow: none;
  }
  input.error, .file-uploads[error] .btn {
    border-width: 1px;
  }

  .error-message {
    // display: none;
  }
  .optional-field-label {
    font-weight: $font-weight-light;
  }

  .disabled, .disabled + .alternate {
    opacity: 0.35;
  }

  .dawn-input-tooltip {
    padding: 0.5em;
    max-width: 310px;

    &:after {
      border-width: 10px;
      margin-top: -10px;
    }
    &:before {
      border-width: 11px;
      margin-top: -11px;
    }

    .small {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
}

.field-enter-active, .field-leave-active {
  transition: opacity 0.5s;
}
.field-enter, .field-leave-to {
  opacity: 0;
  margin: -1px 0 0;
  height: 1px;
  overflow: hidden;
}

.btn {
  &.invalid {
    @include fa-icon($fa-var-exclamation-circle, Solid, inherit);
    &:before {
      margin-left: 0;
      margin-right: 2px;
      vertical-align: middle;
    }
  }
}

.info-field {
  margin: 0;
  padding: 1.5em 0;
  text-align: center;
  font-size: 15px;
  @include theme {
    color: v(border);
    border-top: 1px solid v(background-light);
    border-bottom: 1px solid v(background-light);
  }
}

.mb-offset-64{
  margin-bottom: -64px !important;
}

.description-section-modal {
  display: block;
  padding: 16px;
  margin-left: 50px;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/dialogs/InviteSupplierDialog.vue